// Round to whole cents to avoid floating point drift.
const roundToCents = (n) => Math.round(n * 100) / 100;

const SIZES = ["small", "medium", "large"];

// Aggregate cart product quantities into { small, medium, large } counts.
// `products` is the CartContext products map: { id: { isPhysical, shippingSize, quantity } }.
export function countPhysicalItemsBySize(products) {
  const counts = { small: 0, medium: 0, large: 0 };
  if (!products) return counts;
  Object.keys(products).forEach((key) => {
    const p = products[key];
    if (p && p.isPhysical && SIZES.includes(p.shippingSize)) {
      counts[p.shippingSize] += p.quantity || 0;
    }
  });
  return counts;
}

// Volume-units flat-rate packing. Returns shipping cost in dollars.
// counts: { small?, medium?, large? }
// config: { enabled, mediumUnits, largeUnits, boxes: { small,medium,large: { price, unitCapacity } } }
export function calculateShipping(counts, config) {
  if (!config || !config.enabled || !config.boxes) return 0;

  const small = (counts && counts.small) || 0;
  const medium = (counts && counts.medium) || 0;
  const large = (counts && counts.large) || 0;
  if (small + medium + large === 0) return 0;

  const { boxes, mediumUnits, largeUnits } = config;
  if (!boxes.small || !boxes.medium || !boxes.large) return 0;

  // Config invariant: the largest box must hold the largest single item.
  if (largeUnits > boxes.large.unitCapacity) return 0;

  const totalUnits = small * 1 + medium * mediumUnits + large * largeUnits;

  const largeCap = boxes.large.unitCapacity;
  let cost = 0;

  const fullLargeBoxes = Math.floor(totalUnits / largeCap);
  cost += fullLargeBoxes * boxes.large.price;

  const remainder = totalUnits % largeCap;
  if (remainder > 0) {
    // Smallest box whose capacity covers the remainder. Large always qualifies
    // because remainder < largeCap.
    const candidate = SIZES.map((s) => boxes[s])
      .filter((b) => b.unitCapacity >= remainder)
      .sort((a, b) => a.unitCapacity - b.unitCapacity)[0];
    cost += candidate.price;
  }

  return roundToCents(cost);
}
